import {useEffect, useRef} from "react";

function getDragSize(e) {
    const p = Math.pow;
    const rc = e.target.getBoundingClientRect();
    return p(p(e.clientX - rc.left, 2) + p(e.clientY - rc.top, 2), .5);
}

function useDragToResize(ref) {
    const draggingRef = useRef({});
    useEffect(() => {
        const image = ref.current;
        const dragging = draggingRef.current;
        if (!image) {
            return null;
        }
        function onMouseDown(e) {
            if (e.button === 0) {
                const dragging = draggingRef.current;
                dragging.width = e.target.width;
                dragging.delta = getDragSize(e);
                dragging.dragging = true;
                image.style.cursor = "grabbing";
                e.preventDefault();
            }
        }
        function onMouseMove(e) {
            if (dragging.dragging) {
                if (Math.abs(dragging.delta - getDragSize(e)) > 5) {
                    const width = `${Math.floor(((getDragSize(e)) * dragging.width / dragging.delta))}px`
                    Object.assign(image.style, {
                        position: 'relative',
                        maxWidth: width,
                        width,
                        maxHeight: '',
                        height: 'auto'
                    });
                }
            }
        }
        function onMouseUp(e) {
            const dragging = draggingRef.current;
            if (dragging.dragging) {
                dragging.dragging = false;
                e.target.style.cursor = "grab";
                e.preventDefault();
            }
        }
        function onMouseOut(e) {
            const dragging = draggingRef.current;
            if (dragging.dragging) {
                dragging.dragging = false;
                e.target.style.cursor = "grab";
                e.preventDefault();
            }
        }
        image.addEventListener('mousedown', onMouseDown, true);
        image.addEventListener('mousemove', onMouseMove, false);
        image.addEventListener('mouseup', onMouseUp, true);
        image.addEventListener('mouseout', onMouseOut, true);
        return () => {
            image.removeEventListener('mousedown', onMouseDown);
            image.removeEventListener('mousemove', onMouseMove);
            image.removeEventListener('mouseup', onMouseUp);
            image.removeEventListener('mouseout', onMouseOut);
        };
    }, [ref, draggingRef]);
}

export default useDragToResize;

/*
document.addEventListener('dragging', function () {
    return false
}, false);
*/
